import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
  Row,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { formatBytes } from '../../../helpers/Files';

const AdminPaymentPlan = ({
  client,
  plan,
  processing,
  isManualSubscription,
  handleManageSubscription,
  handleViewInvoices,
  handleCancel,
}) => {
  const intl = useIntl();

  return (
    <Row className="payment-plan">
      <Col>
        <Row>
          <Col lg="6" className="plan-content">
            <div className="plan-header">
              <h4 className="plan-name">
                {
                  intl.formatMessage({
                    defaultMessage: 'Your current plan: {planName}',
                  }, { planName: plan.name })
                }
              </h4>
              <p className="plan-details">
                {
                  intl.formatMessage({
                    defaultMessage: 'Unlimited Users + {storage} of Storage',
                  }, {
                    storage: client.file_size_limit ?
                      formatBytes(client.file_size_limit) :
                      plan.storage,
                  })
                }
              </p>
            </div>
            <div className="plan-body">
              {!isManualSubscription && (
                <>
                  <h5 className="plan-price">
                    {intl.formatMessage({
                      defaultMessage: '{price} per {interval}',
                    }, {
                      price: `$${plan.price.toFixed(2).replace('.00', '')}`,
                      interval: plan.interval_text,
                    })}
                  </h5>
                  <p>
                    {intl.formatMessage({
                      defaultMessage: 'Next payment: <strong>{nextPaymentAt}</strong>',
                    }, { nextPaymentAt: plan.next_payment_at })}
                  </p>
                </>
              )}
              {(plan.usage !== null) && (
                <p>
                  {intl.formatMessage({
                    defaultMessage: 'Your current usage: <strong>{usedStorage}</strong>',
                  }, { usedStorage: formatBytes(plan.usage) || 0 })}
                </p>
              )}
            </div>
          </Col>
          {!isManualSubscription && (
            <Col lg="6" className="plan-button center">
              <Button
                color="primary"
                disabled={processing}
                onClick={handleManageSubscription}
              >
                {processing ?
                  intl.formatMessage({ defaultMessage: 'Please wait...' }) :
                  intl.formatMessage({ defaultMessage: 'Manage your payment method' })}
              </Button>{' '}
              <Button
                color="primary"
                disabled={processing}
                onClick={handleViewInvoices}
              >
                {processing ?
                  intl.formatMessage({ defaultMessage: 'Please wait...' }) :
                  intl.formatMessage({ defaultMessage: 'View invoices' })}
              </Button>
              <br /><br />
              <Button
                color="danger"
                disabled={processing}
                onClick={handleCancel}
              >
                {processing ?
                  intl.formatMessage({ defaultMessage: 'Please wait...' }) :
                  intl.formatMessage({ defaultMessage: 'Cancel your subscription' })}
              </Button>
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
};

AdminPaymentPlan.propTypes = {
  client: PropTypes.object.isRequired,
  plan: PropTypes.object.isRequired,
  processing: PropTypes.bool.isRequired,
  isManualSubscription: PropTypes.bool.isRequired,
  handleManageSubscription: PropTypes.func.isRequired,
  handleViewInvoices: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
};

export default AdminPaymentPlan;
